import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '../../../redux/user/actions';
import { getSelectedProject } from '../../../redux/projects/actions';

import CheckBoxCard from '../../../components/checkBoxCard';

const WidgetGrid = ({ widgets, onWidgetClick, filters }) => {
  const [hasWifiTracker, setHasWifiTracker] = useState(false);
  const [hasHeatmapDevices, setHasHeatmapDevices] = useState(false);

  const user = useSelector(getUser);
  const project = useSelector(getSelectedProject);

  // Check user permission level
  const isAdmin = user && user && user.admin;

  useEffect(() => {
    let hasWifi = false;
    let hasHeatmap = false;
    if (filters) {
      hasWifi = filters.wifiDevices.lenght !== 0;
      hasHeatmap = filters.heatmapDevices.lenght !== 0;
    }
    setHasWifiTracker(hasWifi);
    setHasHeatmapDevices(hasHeatmap);
  }, [filters, project]);

  return (
    <div className="widget-options-container">
      {widgets.map(widget => {
        // Don't display support-only widgets if not admin
        if (!isAdmin && widget.onlyAdminEnabled) return null;

        // Don't display wifi widgets if doesn't have wifiTrack devices
        if (!hasWifiTracker && widget.wifiTracker) return null;

        // Don't display heatmap widgets if doesn't have devices with heatmap configured
        if (!hasHeatmapDevices && widget.display === 'heatmap') return null;

        return (
          <div key={widget.id}>
            <CheckBoxCard
              value={widget.id}
              image={widget.display}
              text={widget.title}
              onChange={onWidgetClick}
              defaultState={widget.selected}
            />
          </div>
        );
      })}
    </div>
  );
};

export default WidgetGrid;
